import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { VinScan, Nesting, Calibration } from "@/components/home/tiles";

const features = [
  { id: "vin", caption: "01 // VIN recognition", title: "Instant VIN & model lookup", desc: "Type a VIN or pick year, make and model — the exact glass set is on screen in seconds.", art: VinScan },
  { id: "nesting", caption: "02 // Nesting optimizer", title: "Smart film nesting", desc: "Every piece auto-arranged on your roll width so you waste less film on every job.", art: Nesting },
  { id: "calibration", caption: "03 // ±0.1 mm tolerance", title: "Plotter & blade calibration", desc: "Cut the test square, dial in offset and depth, and every pattern lands true 1:1.", art: Calibration },
];

const Tile = ({ f, i }) => (
  <Reveal delay={i * 0.08}>
    <motion.article className="tile h-full" whileHover={{ rotateX: -3, rotateY: 3, y: -6 }} transition={{ type: "spring", stiffness: 200, damping: 18 }} data-testid={`feature-tile-${f.id}`}>
      <f.art />
      <div className="p-6">
        <p className="mono-label">{f.caption}</p>
        <h3 className="display mt-3 text-2xl text-white">{f.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-muted">{f.desc}</p>
      </div>
    </motion.article>
  </Reveal>
);

export const WhySwitch = () => (
  <section className="relative mx-auto max-w-7xl px-5 py-14 sm:px-8 lg:py-20" data-testid="why-switch-section">
    <Reveal>
      <p className="mono-label">Xpattern // Why shops switch</p>
      <h2 className="display mt-5 max-w-4xl text-4xl text-white sm:text-5xl lg:text-7xl" data-testid="why-switch-headline">
        Built to give installers <span className="text-cyan-glow">a smarter option.</span>
      </h2>
      <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-testid="why-switch-subcopy">
        Xpattern should grow the business — not become another expensive bill.
      </p>
    </Reveal>

    <div className="mt-10 grid gap-6 md:grid-cols-3" style={{ perspective: 1200 }} data-testid="feature-grid">
      {features.map((f, i) => <Tile key={f.id} f={f} i={i} />)}
    </div>

  </section>
);
